/**
 * Format a percentage value with configurable formatting options
 *
 * @param {number} number - The value to convert to percentage
 * @param {Object} [options] - Configuration options
 * @param {number} [options.decimalPlaces=2] - Number of decimal places to round to ()
 * @param {number} [options.baseValue=100] - The base value (100 for standard percentages)
 * @param {boolean} [options.trimTrailingZeros=true] - Whether to remove trailing decimal zeros
 * @returns {string} Formatted percentage string
 */
export default function formatPercentage(
  number,
  { decimalPlaces = 2, baseValue = 100, trimTrailingZeros = true, withoutPercent = false } = {},
) {
  const percentageValue = Math.min(((number || 0) / baseValue) * 100, 100);
  let formattedValue = percentageValue.toFixed(decimalPlaces);
  if (trimTrailingZeros) {
    formattedValue = formattedValue * 1;
  }
  return withoutPercent ? formattedValue : formattedValue + '%';
}
